import { LocalDate } from "@flockcover/flock-svc-core-types"

// TODO test needed for this

export type EditCoverDatesState = {
  onCover?: LocalDate
  offCover?: LocalDate
  addedInError: boolean
  onCoverInvalid: boolean
  offCoverInvalid: boolean
}

export const initialState: EditCoverDatesState = {
  onCover: undefined,
  offCover: undefined,
  addedInError: false,
  onCoverInvalid: false,
  offCoverInvalid: false,
}

export type EditCoverDatesAction =
  | { type: "setOnCover"; value: LocalDate | undefined }
  | { type: "setOnCoverInvalid"; isInvalid: boolean }
  | { type: "setOffCover"; value: LocalDate | undefined }
  | { type: "setOffCoverInvalid"; isInvalid: boolean }
  | { type: "cancelEdit" }
  | { type: "toggleAddedInError" }

export const editCoverDatesReducer = (
  state: EditCoverDatesState,
  action: EditCoverDatesAction
): EditCoverDatesState => {
  switch (action.type) {
    case `setOnCover`:
      return {
        ...state,
        onCover: action.value,
      }
    case `setOnCoverInvalid`:
      return {
        ...state,
        onCoverInvalid: action.isInvalid,
      }
    case `setOffCover`:
      return {
        ...state,
        offCover: action.value,
      }
    case `setOffCoverInvalid`:
      return {
        ...state,
        offCoverInvalid: action.isInvalid,
      }
    case `toggleAddedInError`:
      return {
        ...state,
        addedInError: !state.addedInError,
      }
    case `cancelEdit`:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
